import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BookingBuilder, ENetworkRequestStatus, ICompany } from 'services/BackendApi';
import { getCompanySelector } from 'store/modules/auth';
import { companyDataSelector, companyLoadSelector, fetchCompanyDataRequestAction } from 'store/modules/companyInfo';
import {
  ledgerDepositStatementTotalsSelector,
  ledgerDepositTotalsLoadingSelector,
} from 'store/modules/ledger/selectors';

export const useDepositAndCreditLimitInfo = (bookingBuilder: BookingBuilder | null, company: ICompany) => {
  if (!bookingBuilder) {
    return {
      depositAccountBalanceCents: 0,
      cannotGetDepositAccountBalance: false,
      creditLimitCents: 0,
      isDefinedCreditLimit: false,
      isEnoughDepositAndCredit: false,
    };
  }
  const depositTotals = useSelector(ledgerDepositStatementTotalsSelector);
  const depositTotalsLoading = useSelector(ledgerDepositTotalsLoadingSelector);
  const depositAccountItem = depositTotals.find(item => item.currency === bookingBuilder.response.currency);
  const depositAccountBalanceCents = depositAccountItem ? -depositAccountItem.netTotal : 0;
  const cannotGetDepositAccountBalance = depositTotalsLoading === ENetworkRequestStatus.ERROR;

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(fetchCompanyDataRequestAction(company.uuid));
  }, [dispatch]);

  const creditLimitMapping = {
    USD: company?.usdCreditLimit,
    EUR: company?.eurCreditLimit,
  };
  const creditLimit = creditLimitMapping[bookingBuilder.response.currency];
  const isDefinedCreditLimit = !!creditLimitMapping[bookingBuilder.response.currency];
  const creditLimitCents = typeof creditLimit === 'string' ? parseFloat(creditLimit) * 100 : 0;
  const isEnoughDepositAndCredit =
    !bookingBuilder.response.totals.oneOrMoreItemsOnRequest &&
    bookingBuilder.response.totals.totalForPricedItemsCents <= depositAccountBalanceCents + creditLimitCents;

  return {
    depositAccountBalanceCents,
    cannotGetDepositAccountBalance,
    creditLimitCents,
    isDefinedCreditLimit,
    isEnoughDepositAndCredit,
  };
};
